export var HomePageView;
(function (HomePageView) {
    HomePageView["EMPLOYEE_VIEW"] = "employee_view";
    HomePageView["EDIT_LAYOUT_VIEW"] = "edit_layout_view";
    HomePageView["EDIT_CONTENT_VIEW"] = "edit_content_view";
})(HomePageView || (HomePageView = {}));
export var RowNames;
(function (RowNames) {
    RowNames["TWO_EQUAL"] = "two_equal";
    RowNames["THREE_EQUAL"] = "three_equal";
    RowNames["FOUR_EQUAL"] = "four_equal";
})(RowNames || (RowNames = {}));
